import { useHistory } from 'react-router-dom';

import { Box, Flex, Image } from '@chakra-ui/react';
import NudgeModalGraphic from '../styles/images/convert-plan-join-waitlist.svg'
import StripeCheckoutButton from '../../payments/components/StripeCheckoutButton';
import LaunchdeckModal from '../../global/components/helper-components/components/LaunchdeckModal';


export default function SubscriptionNudgeModal({ copyText, handleCloseModal, titleText }) {

  const history = useHistory()
  const displayCopyText = <Box>
    <Box textAlign={'center'}>{copyText ? copyText : "Publish unlimited Rooms, get detailed sales intelligence & collaborate with coworkers easily"}</Box>
    <Box mt='1em' color='gray.500' fontSize='0.875em'> All these and more, for just $1 a day </Box>
  </Box>

  const displayContent = () => {
    return (
      <Box w='100%' p='1em 1.8em'>
        <Flex direction='column' mt='1em' justify='center' alignItems='center' px='2em'>
          <Image src={NudgeModalGraphic} height='12em' />

          <Flex w='100%' mt='2em' fontSize='0.9em' color='brandDark.500' fontWeight='500' my='1em' justify='center' textAlign='center'>
            {displayCopyText}
          </Flex>

          <Flex justify='center' align='center' w='100%' mt='0.5em' mb='2em'>
            <StripeCheckoutButton sourceRoute={`${history.location.pathname}`} buttonText="Upgrade" closeModalWhenClicked={true} />
          </Flex>

        </Flex>
      </Box>

    )
  }

  return (
    <LaunchdeckModal
      title={titleText && <Flex gap='1em' justify='flex-start' align='center'>
        <Box fontSize='1.1em' fontWeight='600' textAlign={['center']}>
          {titleText}
        </Box>
      </Flex>}
      handleCloseModal={() => handleCloseModal()}
      showModal={true}
      maxW='35em'
    >
      {displayContent()}
    </LaunchdeckModal>
  )
}